// @TODO: Audit Like Feature

import UnverifiedModal from 'shared/unverified_modal';
import { toIndonesianNumber } from 'shared/string_number_helper';

const Cookies = require('js-cookie');

const UIVoteThumb = {
  ui: {
    root:                '.comments__actions',
    upvote:              '.upvote-button',
    downvote:            '.downvote-button'
  },
  currentTarget: null,

  apiAttribute: {
    upvote: 'likes',
    downvote: 'dislikes'
  },

  setCurrentTarget: function(target){
    this.currentTarget = target;
  },

  getCurrentTarget: function(){
    return $(this.currentTarget);
  },

  new: function(rootNode) {
    var buttonVote = Object.create(UIVoteThumb);

    if (rootNode !== undefined) {
      buttonVote.ui = {root: rootNode, upvote: '.upvote-button', downvote: '.downvote-button'};
    }

    buttonVote.bindAjaxBeforeSend('upvote');
    buttonVote.bindAjaxBeforeSend('downvote');

    return buttonVote;
  },

  updateCount: function(button, count) {
    if(count < 0) count = 0;

    const indoNum = toIndonesianNumber(count.toString());
    if(button==='upvote'){
      $(this.buttonSelector(button)).find('.like__count').attr('data-comment-vote-count', count).text(indoNum);
    } else {
      $(this.buttonSelector(button)).find('.dislike__count').attr('data-comment-vote-count', count).text(indoNum);
    }
  },

  preemptivelyUpdateCount: function(button) {
    var votableID = $(this.buttonSelector(button)).attr('data-votable-id');
    var $like = $('#votable-dislike-' + votableID);
    var $dislike = $('#votable-like-' + votableID);
    var likeCount = parseInt($like.text()) || 0;
    var dislikeCount = parseInt($dislike.text()) || 0;
    var data = {};

    switch(this.getCurrentFlagState(button))  {
      case "like":
        data = {"votes":{"likes":likeCount + 1,"dislikes": dislikeCount - 1}};
        this.toggleUIState('upvote', data.votes);
        break;
      case "unlike":
        data = {"votes":{"likes":likeCount - 1,"dislikes": dislikeCount}};
        this.toggleUIState('upvote', data.votes);
        break;
      case "dislike":
        data = {"votes":{"likes":likeCount - 1,"dislikes": dislikeCount + 1}};
        this.toggleUIState('downvote', data.votes);
        break;
      case "undislike":
        data = {"votes":{"likes":likeCount,"dislikes": dislikeCount - 1}};
        this.toggleUIState('downvote', data.votes);
        break;
    }
  },

  updateFlag: function(button, state) {
    $(this.buttonSelector(button)).attr('data-flag', state);
    $(this.buttonSelector(button)).data('flag', state);
  },

  prepareParams: function(button){
    var $target = $(this.buttonSelector(button));
    var params = {
      vote: {
        flag: $target.attr('data-flag'),
        votable_id: $target.attr('data-votable-id'),
        votable_type: $target.attr('data-votable-type')
      }
    };
    $target.attr('data-params', $.param(params));
    $target.data('params', $.param(params));
  },

  initUnverifiedModal: function(modal){
    Cookies.remove('unverified_user_modal');
    modal.init();
  },

  bindAjaxBeforeSend: function(button){
    $(document).on("ajax:before", this.buttonSelector(button), function(event){
      event.stopPropagation();
      if(!window.currentUser.account_confirmed){
        this.initUnverifiedModal(new UnverifiedModal());
      }else{
        this.setCurrentTarget(event.target);
        this.prepareParams(button);

        this.preemptivelyUpdateCount(button);
      }
    }.bind(this));
  },

  getCurrentFlagState: function(button){
    return $(this.buttonSelector(button)).attr('data-flag') || '';
  },

  getNextFlagState: function(button) {
    var currentState = this.getCurrentFlagState(button);

    if (currentState.substring(0, 2) === 'un') {
      return currentState.replace("un", '');
    } else {
      return "un" + currentState;
    }
  },

  updateUpvote: function(button, nextState){
    var classToReset = [
      'like__icon_like',
      'like__icon_unlike',
      'like-icon',
      'unlike-icon'
    ].join(' ');
    var classToAdd;
    var targetSelector = '.like__icon';

    if(nextState === "unlike")  {
      classToAdd = 'like__icon_unlike unlike-icon';
    }else{
      classToAdd = 'like__icon_like like-icon';
    }

    $(this.buttonSelector(button)).find(targetSelector)
      .removeClass(classToReset)
      .addClass(classToAdd);

    if(nextState === "unlike")  {
      this.animateUpvote(button, nextState);
    }
  },

  animateUpvote: function(button){
    $(this.buttonSelector(button)).find(".like__icon").addClass("like__icon_animate");
    setTimeout(function(){
      $(this.buttonSelector(button)).find(".like__icon").removeClass("like__icon_animate");
    }.bind(this, button), 400);
  },

  updateDownvote: function(button, nextState){
    var classToReset = [
      'dislike__icon_dislike',
      'dislike__icon_undislike',
      'dislike-icon',
      'undislike-icon'
    ].join(' ');
    var classToAdd;
    var targetSelector = '.dislike__icon';

    if(nextState === "undislike")  {
      classToAdd = 'dislike__icon_undislike undislike-icon';
    }else{
      classToAdd = 'dislike__icon_dislike dislike-icon';
    }

    $(this.buttonSelector(button)).find(targetSelector)
      .removeClass(classToReset)
      .addClass(classToAdd);
  },

  switchIconTo: function(button, nextState) {
    if(button === "upvote"){
      this.updateUpvote(button, nextState);
    }else{
      this.updateDownvote(button, nextState);
    }
  },

  updateUIState: function(button, votes){
    var attribute = this.apiAttribute[button];
    var nextState = this.getNextFlagState(button);
    this.switchIconTo(button, nextState);
    this.updateCount(button, votes[attribute]);
    this.updateFlag(button, nextState);
  },

  getSiblingButton: function(button) {
    if (button === 'upvote') {
      return 'downvote';
    } else {
      return 'upvote';
    }
  },

  buttonSelector: function(button) {
    if(this.currentTarget === null){
      return this.ui.root + " " + this.ui[button];
    }else{
      var parent = $(this.currentTarget).parent();
      return parent.find(this.ui[button]);
    }
  },

  toggleUIState: function(button, vote){
    var siblingButton = this.getSiblingButton(button);
    var siblingCurrentState = this.getCurrentFlagState(siblingButton);

    this.updateUIState(button, vote);

    if (siblingCurrentState.substring(0, 2) === 'un') {
      this.updateUIState(siblingButton, vote);
    }
  }
};

export default UIVoteThumb;
